export enum LowStockVariantId {
  THRESHOLD_10 = 'THRESHOLD_10',
  THRESHOLD_100 = 'THRESHOLD_100',
  THRESHOLD_INFINITY = 'THRESHOLD_INFINITY',
}

export interface ThresholdConfig {
  readonly threshold: number;
}

export const LOW_STOCK_CONFIG: Record<LowStockVariantId, ThresholdConfig> = {
  [LowStockVariantId.THRESHOLD_10]: {
    threshold: 10,
  },
  [LowStockVariantId.THRESHOLD_100]: {
    threshold: 100,
  },
  [LowStockVariantId.THRESHOLD_INFINITY]: {
    threshold: Infinity,
  },
} as const;
